import { APP_INITIALIZER, Provider } from '@angular/core';
import {
  Auth0ClientFactory,
  Auth0ClientService,
  AuthClientConfig,
  AuthGuard,
  AuthHttpInterceptor,
  AuthService
} from '@auth0/auth0-angular';
import { MockAuthService } from '@app/shared/qplanning-commons/auth/mock-auth.service';
import { MockAuthGuard } from '@app/shared/qplanning-commons/auth/mock-auth.guard';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { initializeAuth0Client } from '@app/config/initialize-auth0-client';
import { APP_CONFIG } from '@app/config/app-config';

export function provideAuthentication(): Provider[] {
  const allCookies = document.cookie.split(';');
  const authDisabled = allCookies.some(cookie => cookie.trim().startsWith('auth.disabled'));
  const authEnabled = !authDisabled;

  const providers: Provider[] = [
    { provide: AuthService, useClass: authEnabled ? AuthService : MockAuthService },
    { provide: AuthGuard, useClass: authEnabled ? AuthGuard : MockAuthGuard }
  ];

  if (authEnabled) {
    providers.push(
      {
        provide: APP_INITIALIZER,
        useFactory: initializeAuth0Client,
        deps: [AuthClientConfig, APP_CONFIG],
        multi: true
      },
      {
        provide: Auth0ClientService,
        useFactory: Auth0ClientFactory.createClient,
        deps: [AuthClientConfig]
      },
      { provide: HTTP_INTERCEPTORS, useClass: AuthHttpInterceptor, multi: true }
    );
  }

  return providers;
}
